'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { type TabsRootProps } from '~/components/component-library/Tabs/types'

export const TabsRoot = ({ ref, ...props }: TabsRootProps) => (
  <TabsPrimitive.Root ref={ref} {...props} />
)
